var render = function render() {
  var _vm = this,
      _c = _vm._self._c;return _c('el-button', _vm._b({ attrs: { "slot": "reference" }, on: { "click": _vm.remove }, slot: "reference" }, 'el-button', _vm.innerButtonAttrs, false), [_vm.innerButtonAttrs.text ? _c('span', [_vm._v(_vm._s(_vm.innerButtonAttrs.text))]) : _vm._e(), _vm._v(" "), _vm._t("svg-icon")], 2);
};
var staticRenderFns = [];

export { render, staticRenderFns };